
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { SearchFilters } from '~/apps/search/schemas'
import { isLocalStorageAvailable } from '~/utility/isLocalStorageAvailable'

@Component
export default class SearchSummaryBarFilters extends Vue {
  @Prop({ required: true })
    searchFilters: SearchFilters

  get isBoundsSearch(): boolean {
    return !!this.searchFilters.bounds
  }

  showMap = true

  beforeMount() {
    if (isLocalStorageAvailable() && localStorage.getItem('showMap') !== null) {
      this.showMap = localStorage.getItem('showMap') === 'true'
    }
    this.$emit('showMap', this.showMap)
  }

  toggleMap(event) {
    this.showMap = event
    if (isLocalStorageAvailable()) {
      localStorage.setItem('showMap', this.showMap ? 'true' : 'false')
    }
    this.$emit('showMap', event)
  }
}
